/**
 * It takes in a data object and a token, and then it sends a post request to the server with the data
 * and token.
 * @param dataTestimonial - {
 * @param token - "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVmMzY1YzY1YzY5YzY5MDAxM"
 * @returns The response from the server.
 */
import axios from "axios";
export const dataTestimonial = async (dataTestimonial, token) => {
  var data = JSON.stringify(dataTestimonial);

  var config = {
    method: "post",
    url: process.env.REACT_APP_ADMIN_API_URL + "/testimonials",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  try {
    const response = await axios(config)
      .then(function (answer) {
        return answer;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  } catch (error) {
    return error;
  }
};
